import type { FC } from 'react';
import { Tag } from 'antd';
import { Search } from 'lucide-react';

export interface SeoSuggestions {
  suggestedSeoTitle: string;
  suggestedSeoDescription: string;
  suggestedKeywords: string[];
}

interface SeoSuggestionsPanelProps {
  suggestions: SeoSuggestions;
  onAddKeyword: (keyword: string) => void;
  onApplyTitle: (title: string) => void;
  onApplyDescription: (desc: string) => void;
}

const SeoSuggestionsPanel: FC<SeoSuggestionsPanelProps> = ({
  suggestions,
  onAddKeyword,
  onApplyTitle,
  onApplyDescription,
}) => (
  <div className="fc-card border-emerald-200 bg-emerald-50 p-4 dark:border-emerald-800 dark:bg-emerald-900/20">
    <div className="mb-3 flex items-center gap-2">
      <Search className="h-4 w-4 text-emerald-500" />
      <span className="text-xs font-medium uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
        Suggestions SEO
      </span>
    </div>

    {/* Mots-clés suggérés */}
    <div className="mb-3">
      <p className="mb-1 text-xs font-medium text-slate-600 dark:text-slate-300">Mots-clés suggérés</p>
      <div className="flex flex-wrap gap-1">
        {suggestions.suggestedKeywords.map((kw) => (
          <Tag
            key={kw}
            color="green"
            className="cursor-pointer"
            onClick={() => onAddKeyword(kw)}
          >
            + {kw}
          </Tag>
        ))}
      </div>
    </div>

    {/* Titre optimisé */}
    {suggestions.suggestedSeoTitle && (
      <div className="mb-2">
        <p className="mb-1 text-xs font-medium text-slate-600 dark:text-slate-300">Titre optimisé</p>
        <p
          className="cursor-pointer text-sm text-emerald-800 hover:underline dark:text-emerald-200"
          onClick={() => onApplyTitle(suggestions.suggestedSeoTitle)}
          title="Cliquer pour appliquer"
        >
          {suggestions.suggestedSeoTitle}
        </p>
      </div>
    )}

    {/* Description optimisée */}
    {suggestions.suggestedSeoDescription && (
      <div>
        <p className="mb-1 text-xs font-medium text-slate-600 dark:text-slate-300">Description optimisée</p>
        <p
          className="cursor-pointer text-sm text-emerald-800 hover:underline dark:text-emerald-200"
          onClick={() => onApplyDescription(suggestions.suggestedSeoDescription)}
          title="Cliquer pour appliquer"
        >
          {suggestions.suggestedSeoDescription}
        </p>
      </div>
    )}
  </div>
);

export default SeoSuggestionsPanel;
